import {Country} from '../../shared/Models/Country';
import {Model} from './Model';

export class Supplier {
  static SUPPLIER_STATUS_ACTIVE = 'active';
  static SUPPLIER_STATUS_INACTIVE = 'inactive';
  public id: number;
  public number: number;
  public companyName: string;
  public address: string;
  public zipCode: string;
  public city: string;
  public email: string;
  public phone: string;
  public status: boolean;
  public models?: Model[];
  public countryName: string;
  public language: number;
  public deliveryWeek?: number;
  // public country: Country|number|any;
}
